import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { MedicalNote, MedicalNoteType } from '@uplift/api';
import { DischargeNoteSidebarReview } from '../../../components';

export type DischargeNoteSidebarContentProps = {
  dischargeNote: MedicalNote<MedicalNoteType.therapyDischargeNote | MedicalNoteType.psychiatryDischargeNote>;
};

export const DischargeNoteSidebarContent: React.VFC<DischargeNoteSidebarContentProps> = props => {
  const { classes } = useDischargeNoteSidebarContentStyles();

  return (
    <Box py={2} className={classes.root}>
      <DischargeNoteSidebarReview note={props.dischargeNote} />
    </Box>
  );
};

const useDischargeNoteSidebarContentStyles = makeStyles({ name: 'DischargeNoteSidebarContent' })(theme => ({
  root: {
    '& .Uplift-DischargeNoteSection': {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
  }
}));
